import { MarkdownTextPrimitive } from "@assistant-ui/react-markdown";
import { markdownTableComponents } from "@circle-react-shared/AiConversation/markdown/MarkdownTable";
import type { ComponentType } from "react";
import remarkGfm from "remark-gfm";

import styles from "./markdown.module.css";

interface MarkdownTextProps {
  components?: Record<string, ComponentType<any>>;
}

export const MarkdownText = ({ components }: MarkdownTextProps = {}) => (
  <MarkdownTextPrimitive
    className={styles.circleAiMarkdown}
    remarkPlugins={[remarkGfm]}
    components={{ ...markdownTableComponents, ...components }}
  />
);
